$(document).ready(function () {
  $('.live-match-box').each(function () {
    const $section = $(this);
    const $slider = $section.find('.match-slider');
    const $thumbs = $section.find('.match-thumb-slider');
    const $current = $section.find('.current-slide');
    const $total = $section.find('.total-slides');

    if (!$slider.length || !$thumbs.length) {
      return;
    }

    $slider.on('init reInit afterChange', function (event, slick, currentSlide) {
      const current = (currentSlide || 0) + 1;
      $current.text(current);
      $total.text(slick.slideCount);

      $section.find('.match-thumb').removeClass('is-active').attr('aria-current', 'false');

      const activeIndex = slick.currentSlide || 0;

      $section
        .find('.match-thumb-item')
        .eq(activeIndex)
        .find('.match-thumb')
        .addClass('is-active')
        .attr('aria-current', 'true');
    });

    $thumbs.slick({
      slidesToShow: 6,
      slidesToScroll: 1,
      asNavFor: $slider,
      focusOnSelect: true,
      arrows: false,
      dots: false,
      infinite: false,
      variableWidth: false,
      speed: 100,
      responsive: [
        {
          breakpoint: 989,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 749,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });

    $slider.slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: $thumbs,
      arrows: true,
      prevArrow: $section.find('.match-prev'),
      nextArrow: $section.find('.match-next'),
      dots: false,
      infinite: false,
      adaptiveHeight: false,
      speed: 200,
      cssEase: 'ease-out'
    });
  });
});